import api from "../api";
import {iniciarRequisicao, logout} from "../../helpers";
import {STATUS_HTTP} from "../statusHTTP";

export const buscarSecoesCompraPorDepartamento = async (params) => {
  const url = `/secoes/compras/departamentos/${params.iddepartamento}`;

  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.secoes.map(item => {
      return {...item, iddepartamento: params.iddepartamento};
    });
  }

  logout();
}

export const buscarSecoes = async (params) => {
  const {data, status} = await api.get('/secoes', {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.secoes;
  }

  logout();
}
